module.exports = __webpack_public_path__ + "img/barberprologo.d72a5154.png";